import { Layout, DeviceGroups as DeviceGroupsComponent } from "components"
export const DeviceGroups = () => {
 return (
  <Layout>
   <DeviceGroupsComponent />
  </Layout>
 )
}
